export function get(){

	return {

		f32:        'style="font-size: 32px; font-family:sans-serif; text-align: left; margin: 4px; margin-left: 12px;"', 
		f14:        'style="font-size: 14px; font-family:sans-serif; text-align: left; margin: 4px; margin-left: 12px;opacity: 0.76;"',
		f15:				'style="font-size: 15px; font-family: sans-serif; font-weight: 100; margin-left: 12px; margin-top: 16px; margin-bottom: -8px; opacity: 0.76;"', 
		table:      'style="width: 100%; padding: 8px;  "', 
		th:         'style="font-family:sans-serif; text-align: left; padding: 4px; border: 1px solid lightgray; opacity: 0.76;"', 
		thNoline:   'style="font-family:sans-serif; text-align: left; padding: 4px;  opacity: 0.76;"', 
		trGray:     'style=" background-color: #f2f2f2; "', 

		td:         'style="font-family:sans-serif; font-size: 14px; padding: 0px; border: 1px solid lightgray; opacity: 0.99;"', 
		td0:        'style="font-family:sans-serif; padding: 2px;  opacity: 0.99;"', 
		td0t:       'style="font-family:sans-serif; font-size: 12px; padding: 4px; opacity: 0.76;"', 
		tableTitle: 'style="font-size: 16px; font-family:sans-serif; font-weight: bold; margin-left: 12px; margin-top: 16px; margin-bottom: -8px; opacity: 0.76;"', 
	}

	
}




